import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import { Divider, List, ListItem, ListItemText, ListItemIcon, IconButton } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import usePlayground from '../hooks/usePlayground'

type functionType = {
    name: string
    path: string
}

const Sidebar = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    const { menuList } = usePlayground()

    const getMenu = () => {
        return (
            <>
                <StyledDivMenu>
                    <List classes={{ root: classes.list }}>
                        <StyledLink to={'/'}>
                            <ListItem button classes={{ root: classes.listItem, selected: classes.selected }}>
                                <ListItemIcon classes={{ root: classes.listItemIconLeft }}>
                                    <IconButton>
                                        <HomeIcon />
                                    </IconButton>
                                </ListItemIcon>
                                <ListItemText primary={t('BUTTON.GO_TO_MAP')} />
                            </ListItem>
                        </StyledLink>
                    </List>
                    <List>
                        {menuList.map((item: functionType, index: number) => (
                            <StyledLink to={item.path} key={index + 1}>
                                <ListItem
                                    button
                                    key={`playground-${index + 1}`}
                                    classes={{ root: classes.listItem, selected: classes.selected }}
                                >
                                    <ListItemText
                                        primary={item.name}
                                        primaryTypographyProps={{
                                            fontWeight: 'medium',
                                        }}
                                    />
                                </ListItem>
                            </StyledLink>
                        ))}
                    </List>
                </StyledDivMenu>
            </>
        )
    }

    return (
        <StyledDivMenu>
            <StyledDivMenuHeader>Playground</StyledDivMenuHeader>
            <Divider />
            <div>{getMenu()}</div>
        </StyledDivMenu>
    )
}

export default Sidebar

const useStyles = makeStyles((theme: Theme) => ({
    list: {
        paddingBottom: '0px !important',
    },
    listItem: {
        paddingTop: '0px !important',
        '&:hover': { color: `${theme.palette.primary.main} !important` },
        '&$selected': {
            color: `${theme.palette.primary.main} !important`,
            '&:hover': {
                color: `${theme.palette.primary.main} !important`,
            },
        },
    },
    selected: { color: `${theme.palette.primary.main} !important` },
    listItemIconLeft: {
        marginRight: '10px',
        minWidth: '35px !important',
        borderRadius: '5px',
    },
}))

const StyledDivMenu = styled('div')(({ theme }) => ({
    zIndex: 2,
    left: 0,
    width: '200px',
    height: '100%',
    backgroundColor: '#FFFFFF',
    borderRight: `1px solid ${theme.palette.text.disabled}`,
}))

const StyledLink = styled(Link)(({ theme }) => ({
    color: 'inherit',
    textDecoration: 'none',
}))

const StyledDivMenuHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 10px 10px 0px',
    fontWeight: 'bold',
}))
